import React, { useCallback } from "react";
import PropTypes from "prop-types";
import PrimaryButton from "components/v3/primary-button/PrimaryButton";
import DiscountDisclaimer, { DISCOUNT_DISCLAIMER_THEMES } from "components/v3/subscription-form/discount-disclaimer/DiscountDisclaimer";
import { BUTTON_THEME_BLUE_MEDIUM } from "components/v3/primary-button/themes";
import OfferDetails from "./OfferDetails";
import ErrorHandler from "components/v3/error-handler/ErrorHandler";
import REDUX_ERROR_TYPES from "constants/ReduxErrorTypes";
import { FEEDBACK_URL } from "common/constants/Constants";
import { getDate } from "common/utils/dateUtil";
import styles from "./styles.module.scss";

const ConfirmationScreen = ({
    allOffers,
    selectedOffer,
    nextRenewalDate,
    subscriptionId,
    next,
    thinking,
    updateSubscription,
    errors
}) => {
    const { pricing, ratePlanId } = allOffers[selectedOffer];
    const startDate = getDate(nextRenewalDate);

    const focusOnButton = useCallback((node) => {
        node && node.focus();
    }, []);

    const onConfirm = useCallback(() => {
        updateSubscription(subscriptionId, ratePlanId).then(next);
    }, [updateSubscription, subscriptionId, ratePlanId, next]);

    return (
        <>
            <h2 className={ styles.confirmTitle }>Review your new plan</h2>
            <DiscountDisclaimer
                theme={ DISCOUNT_DISCLAIMER_THEMES.SAVE_OFFERS }
                pricing={ pricing }
                startDate={ startDate }
            />
            <OfferDetails pricing={ pricing } startDate={ startDate } />
            <ErrorHandler type={ REDUX_ERROR_TYPES.UPDATE_SUBSCRIPTION } errors={ errors }>
                <ErrorMessage />
            </ErrorHandler>
            <div className={ styles.buttonContainer }>
                <PrimaryButton
                    type="button"
                    ref={ focusOnButton }
                    theme={ BUTTON_THEME_BLUE_MEDIUM }
                    onClick={ onConfirm }
                    text="Claim this offer"
                    thinking={ thinking }
                />
            </div>
        </>
    );
};

const ErrorMessage = ({ error }) => {
    if (!error) {
        return null;
    }

    return (
        <div className={ styles.errorMessage }>
            Unable to apply your upgrade, please contact{ " " }
            <a
                className={ styles.inlineButton }
                href={ FEEDBACK_URL }
            >
                customer&nbsp;support
            </a>
        </div>
    );
};

ConfirmationScreen.propTypes = {
    allOffers: PropTypes.array.isRequired,
    selectedOffer: PropTypes.number.isRequired,
    nextRenewalDate: PropTypes.string.isRequired,
    subscriptionId: PropTypes.number.isRequired,
    next: PropTypes.func.isRequired,
    thinking: PropTypes.string,
    updateSubscription: PropTypes.func.isRequired,
    errors: PropTypes.object
};

ErrorMessage.propTypes = {
    error: PropTypes.shape({
        type: PropTypes.string,
        message: PropTypes.string.isRequired
    })
};

export default ConfirmationScreen;
